import React from 'react';
import { Icon } from './Icon';

const OccupancyIcon = ({ size, color }: Props) => {
  return (
    <Icon type="users" color={`bg-label-${color === 'purple' ? 'primary-purple' : color}`} size={size} />
  );
}

interface Props {
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl',
  color: 'info' | 'orange' | 'purple'
}

export { OccupancyIcon };